<template>
  <div class="nav">
    <ul>
      <li v-for="item in navData">
        <router-link :to="item.url" :class="item.name"><p>{{item.title}}</p ></router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data: () => ({
    navData: [
      {
        url: '/',
        name: 'icon-we',
        title: '产品介绍'
      },
      {
        url: '/case',
        name: 'icon-case',
        title: '客户案例'
      },
      {
        url: '/contact',
        name: 'icon-product',
        title: '联系我们'
      }
    ]
  })
}
</script>
<style lang="scss" scoped>
  .nav {
    width: 100%;
    height: 1rem;
    background-color: #f9f9f9;
    position: fixed;
    left: 0;
    bottom: 0;
    box-shadow: 0 0 3px rgba(0,0,0,0.3);

    ul {
      display: flex;

      li {
        flex: 1;
        text-align: center;


        a {
          display: block;
          padding-top: 0.15rem;
          font-size: 0.38rem;
          color: #999;
          text-align: center;

          p {
            font-size:0.17rem;
            margin-top:0.1rem;
          }
        }
        .router-link-exact-active {
          color: #3b5391;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/nav.vue